/**
 * Extracts the path component from a given URL.
 *
 * @param {string} url - The URL from which to extract the path.
 * @returns {string} - The path component of the URL, or an empty string if the URL is invalid.
 *
 * @example
 * // Returns '/path/to/resource'
 * const path = getPathFromUrl('https://example.com/path/to/resource?query=123');
 *
 * @example
 * // Returns ''
 * const path = getPathFromUrl('invalid-url');
 */
export const getPathFromUrl = (url: string): string => {
  try {
    const parsedUrl = new URL(url);
    return parsedUrl.pathname;
  } catch (error) {
    return '';
  }
};
